<template>
  <div class="fill-height">
    <v-layout row wrap>
      <v-flex>
        <section>
          <v-row 
            align="center" 
            justify="center"
            style="height: 100vh;">
            <v-col v-if="rps === 'lg'"
              cols="12" 
              md="8" 
              sm="6"
              class="py-0">
              <v-img 
                width="100%"
                height="100vh"
                alt="umb" 
                gradient="to top, rgba(0, 0, 0, .75), rgba(0, 0, 0, 0) calc(100% - 600px)"
                :src="Object.keys(company).length > 0 ? company.banner_url : require('@/assets/background/basic_bg.png')"
                class="ma-auto">
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height"
                    align="center"
                    justify="center">
                    <v-progress-circular 
                      indeterminate 
                      :color="set_color">
                    </v-progress-circular>
                  </v-row>
                </template>

                <div
                  style="position: absolute; bottom: 25px; left: 40px;">
                  <div
                    class="body-2 white--text">
                    Copyright@{{ Object.keys(company).length > 0 ? company.company_name : 'PT Amanata' }} Yogyakarta 2023
                  </div>
                </div>
              </v-img>
            </v-col>

            <v-col 
              cols="12" 
              md="4" 
              sm="6">
              <v-card
                flat
                color="transparent"
                :class="rps === 'lg' ? 'px-16' : 'px-6'">
                <div
                  :class="rps === 'lg' ? 'pr-8' : ''">
                  <div
                    class="pb-16 mb-16">
                    <v-img 
                      contain
                      :width="Object.keys(company).length > 0 ? 350 : 175"
                      height="175"
                      alt="umb" 
                      :src="Object.keys(company).length > 0 ? company.logo : require('@/assets/logo/favicon.svg')"
                      class="ma-auto">
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height"
                          align="center"
                          justify="center">
                          <v-progress-circular 
                            indeterminate 
                            :color="set_color">
                          </v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>

                    <div v-if="Object.keys(company).length < 1"
                      class="text-h3 font-weight-bold text-center mt-8"
                      :style="`color: ${set_color};`">
                      {{ Object.keys(company).length > 0 ? company.company_name : 'amanata' }}
                    </div>
                  </div>

                  <div>
                    <div
                      class="mb-6">
                      <div
                        class="title font-weight-bold mb-2"
                        :style="`color: ${set_color};`">
                        Masuk
                      </div>

                      <div
                        class="body-2 line-text-first"
                        style="opacity: 60%;">
                        Silahkan masuk menggunakan username yang telah terdaftar.
                      </div>
                    </div>

                    <ValidationObserver 
                      ref="observer">
                      <v-form class="text-left mb-6">
                        <ValidationProvider 
                          name="username" 
                          rules="required" 
                          v-slot="{ errors }">
                          <v-text-field
                            v-on:keyup.enter="save"
                            class="no_box"
                            solo
                            :color="set_color"
                            placeholder="Username"
                            prepend-inner-icon="mdi-account-outline"

                            v-model="form.username"
                            :error-messages="errors"
                            required>
                          </v-text-field>
                        </ValidationProvider>

                        <ValidationProvider 
                          name="password" 
                          rules="required|min:8|max:20" 
                          v-slot="{ errors }">
                          <v-text-field
                            v-on:keyup.enter="save"
                            class="no_box"
                            solo
                            :color="set_color"
                            placeholder="Password"
                            :type="show ? 'text' : 'password'"
                            prepend-inner-icon="mdi-lock-outline"
                            :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                            @click:append="show = !show"
                            :counter="20"
                            
                            v-model="form.password"
                            :error-messages="errors"
                            required>
                          </v-text-field>
                        </ValidationProvider>
                      </v-form>
                    </ValidationObserver>

                    <div 
                      class="text-center mb-6">
                      <v-alert 
                        type="error" 
                        text 
                        dense 
                        prominent 
                        v-show="message.error !== ''">
                        {{ message.error }}
                      </v-alert>

                      <v-btn
                        v-on:keyup.enter="save"
                        :disabled="process.form"
                        :loading="process.form"
                        @click="save"
                        block
                        x-large
                        width="170"
                        elevation="0"
                        class="title font-weight-bold white--text text-capitalize btn_auth"
                        style="border-radius: 10px;"
                        :style="`background: linear-gradient(180deg, ${set_color_rgb} 0%, ${set_color} 100%);`">
                        <div
                          class="btn_auth_in"
                          :style="`background: linear-gradient(180deg, ${set_color_rgb} 0%, ${set_color_up} 100%);`">
                          Masuk
                        </div>
                      </v-btn>
                    </div>

                    <div
                      class="body-2 text-center"
                      style="opacity: 60%;">
                      Powered by Amanata
                    </div>
                  </div>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { TokenService } from "@/service/Storage.Service";
  import { get, post, put, destroy } from "@/service/Axios";
  export default {
    data() {
      return {
        show: false,
        form: {
          username: '',
          password: '',
          device: 'web'
        },
        process: {
          form: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    computed: {
      rps() {
        return this.$vuetify.breakpoint.name
      },
      company () {
        return this.$store.state.company
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r+35}, ${g+37}, ${b}, 0.97)`
      }
    },
    mounted () {
      this.fetch()
    },
    methods: {
      async save () {
        this.message.error = ''

        const isValid = await this.$refs.observer.validate()
        if (isValid) {
          this.process.form = true

          await post('admin/auth/login', {
            data: this.form
          })
          .then(response => {
            let res = response.data

            if (res.status === 200) {
              let user = res.results.data,
                  menu = [
                    {
                      title: 'Dashboard',
                      icon: 'mdi-view-dashboard-outline',
                      link: '/dashboard',
                      active: true,
                      sub_menu: []
                    },
                    {
                      title: 'Monitoring',
                      icon: 'mdi-map-search-outline',
                      link: '/monitoring',
                      active: false,
                      sub_menu: [
                        // {
                        //   title: 'Maping',
                        //   link: '/maping',
                        //   active: false
                        // },
                        {
                          title: 'Pegawai Presensi (Hari Ini)',
                          link: '/attendance_monitoring',
                          active: false
                        },
                        {
                          title: 'Pegawai Ijin (Hari Ini)',
                          link: '/permission',
                          active: false
                        }
                      ]
                    },
                    {
                      title: 'Unit',
                      icon: 'mdi-abacus',
                      link: '/unit',
                      active: false,
                      sub_menu: []
                    },
                    {
                      title: 'Pegawai',
                      icon: 'mdi-account-supervisor-outline',
                      link: '/officer',
                      active: false,
                      sub_menu: []
                    },
                    {
                      title: 'Presensi',
                      icon: 'mdi-clipboard-text-clock-outline',
                      link: '/attendance',
                      active: false,
                      sub_menu: [
                        {
                          title: 'Data Presensi',
                          link: '/attendance',
                          active: false
                        },

                        {
                          title: 'Keterlambatan',
                          link: '/attendance/late',
                          active: false
                        },
                        {
                          title: 'Rekap Presensi',
                          link: '/attendance/rekap',
                          active: false
                        }
                      ]
                    },
                    {
                      title: 'Lembur',
                      icon: 'mdi-cash-clock',
                      link: '/overtime',
                      active: false,
                      sub_menu: [
                        {
                          title: 'Ajuan Lembur',
                          link: '/overtime',
                          active: false
                        },
                        {
                          title: 'Riwayat Lembur',
                          link: '/overtime/history',
                          active: false
                        }
                      ]
                    },
                    {
                      title: 'Informasi Gaji',
                      icon: 'mdi-cash-multiple',
                      link: '/salary',
                      active: false,
                      sub_menu: [
                        {
                          title: 'Gaji Sekarang',
                          link: '/salary',
                          active: false
                        },
                        {
                          title: 'Gaji Bulanan',
                          link: '/salary/month',
                          active: false
                        }
                      ]
                    },
                    {
                      title: 'Perijinan',
                      icon: 'mdi-clipboard-check-multiple-outline',
                      link: '/licensing',
                      active: false,
                      sub_menu: [
                        // {
                        //   title: 'Data Sisa Ijin',
                        //   link: '/licensing/holiday',
                        //   active: false
                        // },
                        {
                          title: 'Ajuan Ijin',
                          link: '/licensing/submission',
                          active: false
                        },
                        {
                          title: 'Riwayat Ijin',
                          link: '/licensing/permission',
                          active: false
                        }
                      ]
                    },
                    {
                      title: 'Laporan Pegawai',
                      icon: 'mdi-finance',
                      link: '/report',
                      active: false,
                      sub_menu: []
                    },
                    {
                      title: 'Pengumuman',
                      icon: 'mdi-bullhorn-variant-outline',
                      link: '/announcement',
                      active: false,
                      sub_menu: []
                    },
                    {
                      title: 'Audit Trail',
                      icon: 'mdi-monitor-account',
                      link: '/audit',
                      active: false,
                      sub_menu: []
                    },
                    {
                      title: 'Konfigurasi',
                      icon: 'mdi-cog-outline',
                      link: '/setting',
                      active: false,
                      sub_menu: []
                    }
                  ]

              TokenService.saveToken(
                res.results.token,
                JSON.stringify(user),
                JSON.stringify(menu)
              )

              TokenService.saveReload(false)

              window.location = `${process.env.BASE_URL}dashboard`
            } else {
              this.process.form = false
              this.message.error = res.message
            }
          })
        }
      },
      async fetch () {
        await get('config')
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            res.results.data[0].color = JSON.parse(res.results.data[0].color)

            TokenService.saveCompany(JSON.stringify(res.results.data[0]))

            this.$store.commit("setCompany", res.results.data[0])
            
            if (res.results.data[0].color.length > 0) {
              res.results.data[0].color.map((obj) => {
                if (obj.active) {
                  TokenService.saveColor(obj.hex)

                  this.$store.commit("setColor", obj.hex)
                }
              })
            } else {
              TokenService.saveColor('#7550e1')

              this.$store.commit("setColor", '#7550e1')
            }
          }
        })
      }
    }
  }
</script>